// Cart add-on merge UI (Easify/TPO).
(function () {
  const MOUNT_ATTR = 'data-easify-merged-addons';
  let rerunTimer = null;
  const STYLE_ID = 'easify-merged-addons-style';
  let runOnceInProgress = false;

  function isCartLikePage() {
    return !!document.querySelector('form[aria-label="cart checkout"] ul.cartitems--list');
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.easify-merged-addons{margin-top:10px;padding-top:10px;border-top:1px solid rgba(0,0,0,.08)}' +
      '.easify-merged-addons__title{font-weight:600;margin-bottom:6px}' +
      '.easify-merged-addons__list{margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:4px}' +
      '.easify-merged-addons__item{display:flex;gap:8px;justify-content:space-between;align-items:baseline}' +
      '.easify-merged-addons__item-title{flex:1;min-width:0}' +
      '.easify-merged-addons__item-price{white-space:nowrap;font-weight:600}' +
      '.easify-merged-addons__item-price--original{opacity:.65;font-weight:500;margin-right:6px}' +
      '.easify-merged-addons__item-price--final{font-weight:700}' +
      '.zoco-merged-line-total{margin-top:6px;font-size:.9375rem;line-height:1.3}' +
      '.zoco-merged-line-total__label{display:block;color:rgba(0,0,0,.65)}' +
      '.zoco-merged-line-total__price{font-weight:700}' +
      'html.zoco-correct-cart-total [data-cart-total]{display:none!important}' +
      '.zoco-corrected-cart-total{display:inline-block}';

    // Hide original add-on rows without `display:none` (some apps read/inject based on DOM presence).
    style.textContent +=
      '.addon-row-hidden{position:absolute !important;left:-10000px !important;top:auto !important;width:1px !important;height:1px !important;overflow:hidden !important;pointer-events:none !important;}';

    document.head.appendChild(style);
  }

  function safeJsonParse(s) {
    try {
      return JSON.parse(s);
    } catch (e) {
      return null;
    }
  }

  function toArrayMaybeJson(val) {
    if (Array.isArray(val)) return val;
    if (typeof val !== 'string') return [];
    const trimmed = val.trim();
    if (!trimmed) return [];
    const parsed = safeJsonParse(trimmed);
    return Array.isArray(parsed) ? parsed : [];
  }

  function formatMoneyCents(cents) {
    let n = Math.round(typeof cents === 'number' ? cents : parseInt(String(cents || '0'), 10));
    if (!Number.isFinite(n)) n = 0;
    const sh = window.Shopify;
    const cur = sh && sh.currency;
    let activeCode = null;
    try {
      if (cur && (cur.active || cur.currency || cur.current)) {
        activeCode = String(cur.active || cur.currency || cur.current).trim().toUpperCase();
      }
    } catch (e1) {}
    const localeByCurrency = {
      PLN: 'pl-PL',
      EUR: 'de-DE',
      GBP: 'en-GB',
      USD: 'en-US',
      CAD: 'en-CA',
      AUD: 'en-AU',
      JPY: 'ja-JP',
      CHF: 'de-CH',
      SEK: 'sv-SE',
      NOK: 'nb-NO',
      DKK: 'da-DK',
      CZK: 'cs-CZ',
      HUF: 'hu-HU',
      RON: 'ro-RO',
      MXN: 'es-MX',
      BRL: 'pt-BR',
      INR: 'en-IN',
    };
    if (activeCode && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        const loc =
          localeByCurrency[activeCode] ||
          (document.documentElement && document.documentElement.lang
            ? String(document.documentElement.lang).trim()
            : undefined);
        return new Intl.NumberFormat(loc, { style: 'currency', currency: activeCode }).format(n / 100);
      } catch (e2) {}
    }
    if (sh && typeof sh.formatMoney === 'function') {
      try {
        const mf =
          (cur && (cur.money_format || (cur.currency_code_enabled && cur.money_with_currency_format))) ||
          sh.money_format;
        return mf ? sh.formatMoney(n, mf) : sh.formatMoney(n);
      } catch (e3) {}
    }
    return String(n / 100);
  }

  function getCartListEl() {
    return document.querySelector('ul.cartitems--list[data-cart-item-list], ul.cartitems--list');
  }

  function escapeAttrValue(val) {
    return String(val || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }

  function escapeHtml(val) {
    return String(val || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cartRowByLineKey(lineKey) {
    if (!lineKey) return null;
    const k = String(lineKey);
    const list = getCartListEl();
    if (list) {
      const inList = list.querySelector('li[data-cartitem-key="' + escapeAttrValue(k) + '"]');
      if (inList) return inList;
    }
    return document.querySelector('li[data-cartitem-key="' + escapeAttrValue(k) + '"]');
  }

  function hideAddonRow(item) {
    const row = item && item.key ? cartRowByLineKey(item.key) : null;
    if (!row) return;
    row.classList.add('addon-row-hidden');
    row.setAttribute('aria-hidden', 'true');
  }

  function unhideAddonRows(listEl) {
    const rows = (listEl || document).querySelectorAll('.addon-row-hidden');
    for (let i = 0; i < rows.length; i++) {
      rows[i].classList.remove('addon-row-hidden');
      rows[i].removeAttribute('aria-hidden');
    }
  }

  function isCheckoutButtonEnabled(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return false;
    try {
      const style = window.getComputedStyle(btn);
      if (style.pointerEvents === 'none') return false;
    } catch (e) {}
    return true;
  }

  function syncSamitaCheckoutClone() {
    const root = document.querySelector('.cart-checkout');
    if (!root) return;
    const clone = root.querySelector('.samitaWS-clone-checkout-button');
    const original = root.querySelector('.samitaWS-original-checkout-button[name="checkout"]');
    if (!clone || !original || !isCheckoutButtonEnabled(original)) return;
    if (clone.style.pointerEvents === 'none') clone.style.pointerEvents = 'auto';
    if (clone.disabled) clone.disabled = false;
    if (clone.getAttribute('aria-disabled') === 'true') clone.setAttribute('aria-disabled', 'false');
  }

  function mutationTouchesSamitaPrice(records) {
    if (!records) return false;
    for (let i = 0; i < records.length; i++) {
      const r = records[i];
      const t = r.target;
      if (t && t.nodeType === 1 && t.matches && t.matches('.samitaWS-customized-price')) return true;
      if (t && t.parentElement && t.parentElement.matches && t.parentElement.matches('.samitaWS-customized-price')) return true;
      const added = r.addedNodes || [];
      for (let j = 0; j < added.length; j++) {
        const n = added[j];
        if (n && n.nodeType === 1 && n.matches && n.matches('.samitaWS-customized-price')) return true;
        if (n && n.nodeType === 1 && n.querySelector && n.querySelector('.samitaWS-customized-price')) return true;
      }
    }
    return false;
  }

  function cartLineMoneyCents(item, key) {
    if (!item || key == null) return null;
    const v = item[key];
    if (v == null) return null;
    const n = typeof v === 'number' ? v : parseInt(String(v), 10);
    return Number.isFinite(n) ? n : null;
  }

  function lineAndOrig(item, qtyOpt) {
    let qty = qtyOpt != null ? qtyOpt : item && item.quantity != null ? item.quantity : null;
    if (qty != null && typeof qty !== 'number') qty = parseInt(String(qty).trim(), 10);
    if (qty != null && !Number.isFinite(qty)) qty = null;

    let line = cartLineMoneyCents(item, 'final_line_price');
    if (line == null) line = cartLineMoneyCents(item, 'line_price');
    if (line == null && item && item.price != null && qty != null) {
      const unit = cartLineMoneyCents(item, 'price');
      if (unit != null) line = unit * qty;
    }

    let orig = cartLineMoneyCents(item, 'original_line_price');
    if (orig == null && item && item.original_price != null && qty != null) {
      const uo = cartLineMoneyCents(item, 'original_price');
      if (uo != null) orig = uo * qty;
    }
    return { line, orig };
  }

  function moneyTextToMajorUnits(str) {
    let s = String(str == null ? '' : str)
      .replace(/\u00a0|\u202f/g, ' ')
      .trim();
    s = s.replace(/['\u2019]/g, '');
    let rep = 0;
    while (rep < 24 && /(\d)\s+(\d)/.test(s)) {
      s = s.replace(/(\d)\s+(\d)/g, '$1$2');
      rep++;
    }
    s = s.replace(/[^\d.,-]/g, '');
    if (!s || s === '-') return NaN;
    let neg = s.charAt(0) === '-';
    if (neg) s = s.slice(1);
    s = s.replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let intPart;
    let decPart = '';
    if (lastComma === -1 && lastDot === -1) {
      intPart = s;
    } else if (lastComma > lastDot) {
      const partsC = s.split(',');
      decPart = partsC.length ? partsC.pop() : '';
      intPart = partsC.join('');
      intPart = intPart.replace(/\./g, '');
      decPart = String(decPart || '').replace(/[^\d]/g, '');
    } else {
      const partsD = s.split('.');
      decPart = partsD.length ? partsD.pop() : '';
      intPart = partsD.join('');
      intPart = intPart.replace(/,/g, '');
      decPart = String(decPart || '').replace(/[^\d]/g, '');
    }
    intPart = String(intPart || '').replace(/[^\d]/g, '');
    if (!intPart && !decPart) return NaN;
    const n = parseFloat(intPart + (decPart ? '.' + decPart : ''));
    return Number.isFinite(n) ? (neg ? -n : n) : NaN;
  }

  function moneyTextToCents(text) {
    const n = moneyTextToMajorUnits(String(text || ''));
    if (!Number.isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function getDisplayedLineCents(row) {
    if (!row || !row.querySelector) return null;
    const priceEl =
      row.querySelector('.cart-item__total [data-cartitem-total] .samitaWS-customized-price') ||
      row.querySelector('[data-cartitem-total] .samitaWS-customized-price');
    const cents = priceEl ? moneyTextToCents(priceEl.textContent) : null;
    return cents != null ? cents : null;
  }

  function getDisplayedOriginalLineCents(row) {
    if (!row || !row.querySelector) return null;
    const priceEl =
      row.querySelector('.cart-item__total [data-cartitem-total] .samitaWS-customized-original-price') ||
      row.querySelector('[data-cartitem-total] .samitaWS-customized-original-price');
    const cents = priceEl ? moneyTextToCents(priceEl.textContent) : null;
    return cents != null ? cents : null;
  }

  function effectiveLineAndOrig(item, qtyOpt, row) {
    const base = lineAndOrig(item, qtyOpt);
    let line = getDisplayedLineCents(row);
    let orig = getDisplayedOriginalLineCents(row);
    if (line != null && orig != null && base.orig != null && orig > 0 && base.orig > 0 && orig !== base.orig) {
      const ratio = base.orig / orig;
      line = Math.round(line * ratio);
      orig = base.orig;
    }
    return {
      line: line == null ? base.line : line,
      orig: orig == null ? base.orig : orig,
    };
  }

  function getAddonVariantTitle(item) {
    if (!item) return null;
    const vt = typeof item.variant_title === 'string' ? item.variant_title.trim() : '';
    if (vt && vt.toLowerCase() !== 'default title') return vt;
    const t = typeof item.title === 'string' ? item.title.trim() : '';
    if (t) {
      const idx = t.lastIndexOf(' - ');
      if (idx >= 0 && idx + 3 < t.length) {
        const tail = t.slice(idx + 3).trim();
        if (tail && tail.toLowerCase() !== 'default title') return tail;
      }
    }
    return null;
  }

  function getAddonOptionValueFromDom(item) {
    const row = item && item.key ? cartRowByLineKey(item.key) : null;
    if (!row) return null;
    const el = row.querySelector('.cart-item-product-options__option-value');
    const s = el && el.textContent ? String(el.textContent).trim() : '';
    return s || null;
  }

  function ensureMount(mainRow) {
    const content = mainRow.querySelector('.cart-item--content') || mainRow.querySelector('.cart-item--inner') || mainRow;
    let mount = content.querySelector('[' + MOUNT_ATTR + '="1"]');

    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute(MOUNT_ATTR, '1');
      mount.className = 'easify-merged-addons';
    }

    const options = content.querySelector('.cart-item-product-options');
    const price = content.querySelector('.cart-item--content-price');
    if (price && price.parentNode) price.parentNode.insertBefore(mount, price.nextSibling);
    else if (options && options.parentNode) options.parentNode.insertBefore(mount, options.nextSibling);
    else {
      const title = content.querySelector('.cart-item--content-title');
      if (title && title.parentNode) title.parentNode.insertBefore(mount, title.nextSibling);
      else content.appendChild(mount);
    }
    return mount;
  }

  function renderMount(mount, addons, mainQty) {
    if (!mount) return;
    if (!addons || !addons.length) {
      if (mount.innerHTML !== '') mount.innerHTML = '';
      return;
    }

    let html = '<ul class="easify-merged-addons__list">';
    for (let i = 0; i < addons.length; i++) {
      const a = addons[i];
      const title = (getAddonVariantTitle(a) || getAddonOptionValueFromDom(a) || 'Add-on').trim();
      let qty =
        typeof mainQty === 'number' && Number.isFinite(mainQty)
          ? mainQty
          : a && typeof a.quantity === 'number'
            ? a.quantity
            : a && a.quantity != null
              ? parseInt(String(a.quantity).trim(), 10)
              : null;
      if (qty != null && !Number.isFinite(qty)) qty = null;

      const addonRow = a && a.key ? cartRowByLineKey(a.key) : null;
      const p = effectiveLineAndOrig(a, qty, addonRow);
      const hasDiscount = p.orig != null && p.line != null && p.orig > p.line;

      html +=
        '<li class="easify-merged-addons__item">' +
        '<span class="easify-merged-addons__item-title">' +
        escapeHtml(title) +
        '</span>' +
        (p.line != null
          ? '<span class="easify-merged-addons__item-price">' +
            (hasDiscount ? '<s class="easify-merged-addons__item-price--original">' + formatMoneyCents(p.orig) + '</s> ' : '') +
            '<span class="easify-merged-addons__item-price--final">' +
            formatMoneyCents(p.line) +
            '</span>' +
            '</span>'
          : '') +
        '</li>';
    }
    html += '</ul>';

    if (mount.innerHTML !== html) mount.innerHTML = html;
  }

  function hideRowOriginalTotal(mainRow) {
    const original = mainRow && mainRow.querySelector ? mainRow.querySelector('.cart-item__total > s.original-price') : null;
    if (!original) return;
    original.hidden = true;
    original.setAttribute('aria-hidden', 'true');
  }

  function clearCombinedLineTotal(mainRow) {
    if (!mainRow || !mainRow.querySelector) return;
    const existing = mainRow.querySelector('[data-zoco-merged-line-total]');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    const original = mainRow.querySelector('.cart-item__total > s.original-price');
    if (original) {
      original.hidden = false;
      original.removeAttribute('aria-hidden');
    }
  }

  function updateCombinedLineTotal(mainRow, mainItem, addons, mainQty) {
    if (!mainRow || !mainItem || !addons || !addons.length) {
      clearCombinedLineTotal(mainRow);
      return;
    }

    let total = 0;
    let hasTotal = false;
    const mainTotals = effectiveLineAndOrig(mainItem, mainQty, mainRow);
    if (mainTotals.line != null) {
      total += mainTotals.line;
      hasTotal = true;
    }

    for (let i = 0; i < addons.length; i++) {
      const addonRow = addons[i] && addons[i].key ? cartRowByLineKey(addons[i].key) : null;
      const addonTotals = effectiveLineAndOrig(addons[i], mainQty, addonRow);
      if (addonTotals.line == null) continue;
      total += addonTotals.line;
      hasTotal = true;
    }

    if (!hasTotal) {
      clearCombinedLineTotal(mainRow);
      return;
    }

    hideRowOriginalTotal(mainRow);

    const totalEl = mainRow.querySelector('.cart-item__total');
    const priceEl = totalEl && totalEl.querySelector ? totalEl.querySelector('[data-cartitem-total]') : null;
    if (!totalEl || !priceEl) return;

    let combined = totalEl.querySelector('[data-zoco-merged-line-total]');
    if (!combined) {
      combined = document.createElement('div');
      combined.setAttribute('data-zoco-merged-line-total', '1');
      combined.className = 'zoco-merged-line-total';
      if (priceEl.nextSibling) totalEl.insertBefore(combined, priceEl.nextSibling);
      else totalEl.appendChild(combined);
    }

    const html =
      '<span class="zoco-merged-line-total__label">Line total incl. add-ons</span>' +
      '<span class="zoco-merged-line-total__price">' +
      formatMoneyCents(total) +
      '</span>';
    if (combined.innerHTML !== html) combined.innerHTML = html;
  }

  function buildMainByAddonKey(cart) {
    const mainByAddonKey = Object.create(null);
    const items = (cart && cart.items) || [];
    for (let mi = 0; mi < items.length; mi++) {
      const main = items[mi];
      if (!main || !main.properties) continue;
      if (main.properties._tpo_main_product_id) continue;
      const rawKeys = main.properties._tpo_add_on_keys;
      if (!rawKeys) continue;
      const keys = toArrayMaybeJson(rawKeys);
      if (!keys || !keys.length) continue;
      for (let ki = 0; ki < keys.length; ki++) {
        const k = String(keys[ki] || '').trim();
        if (!k) continue;
        mainByAddonKey[k] = main;
      }
    }
    return mainByAddonKey;
  }

  async function removeOrphanTpoAddonsIfNeeded(cart) {
    const items = (cart && cart.items) || [];
    if (!items.length) return cart;

    const mainByAddonKey = buildMainByAddonKey(cart);
    const updates = Object.create(null);

    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      if (!it || !it.key || !it.properties) continue;
      if (!it.properties._tpo_main_product_id) continue;
      const addonKey = String(it.properties._tpo_add_on_key || '').trim();
      if (!addonKey) continue;
      if (!mainByAddonKey[addonKey]) {
        updates[String(it.key)] = 0;
      }
    }

    const keys = Object.keys(updates);
    if (!keys.length) return cart;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = root.slice(-1) === '/' ? root : root + '/';
    const updateUrl = base + 'cart/update.js';

    try {
      const res = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      if (!res.ok) return cart;
      const next = await res.json();
      return next && next.items ? next : cart;
    } catch (e) {
      return cart;
    }
  }


  function buildAddonMap(cart) {
    const byMainKeyOrVariant = Object.create(null);
    const items = (cart && cart.items) || [];

    const mainByAddonKey = buildMainByAddonKey(cart);

    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      if (!it || !it.properties) continue;
      const mainId = it.properties._tpo_main_product_id;
      if (!mainId) continue;

      const addonKey = String(it.properties._tpo_add_on_key || '').trim();
      const mappedMain = addonKey && mainByAddonKey[addonKey] ? mainByAddonKey[addonKey] : null;
      if (!mappedMain || !mappedMain.key) continue;
      const bucketKey = String(mappedMain.key);

      if (!byMainKeyOrVariant[bucketKey]) byMainKeyOrVariant[bucketKey] = { main: mappedMain, addons: [] };
      byMainKeyOrVariant[bucketKey].addons.push(it);
    }

    return byMainKeyOrVariant;
  }

  function updateCorrectedCartTotal(cart, addOnsByMain) {
    const items = (cart && cart.items) || [];
    const seen = Object.create(null);
    let hasDuplicate = false;
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      if (!it || !it.id || (it.properties && it.properties._tpo_main_product_id)) continue;
      if (String(it.handle || '').toLowerCase() === 'setup-fee') continue;
      if (seen[it.id]) {
        hasDuplicate = true;
        break;
      }
      seen[it.id] = 1;
    }

    const existing = document.querySelectorAll('[data-zoco-corrected-cart-total]');
    if (!hasDuplicate) {
      document.documentElement.classList.remove('zoco-correct-cart-total');
      for (let ex = 0; ex < existing.length; ex++) existing[ex].remove();
      return;
    }

    const addonKeys = Object.create(null);
    const mainKeys = Object.keys(addOnsByMain || {});
    for (let m = 0; m < mainKeys.length; m++) {
      const addons = (addOnsByMain[mainKeys[m]] && addOnsByMain[mainKeys[m]].addons) || [];
      for (let a = 0; a < addons.length; a++) if (addons[a] && addons[a].key) addonKeys[addons[a].key] = 1;
    }

    let total = 0;
    let originalTotal = 0;
    for (let j = 0; j < items.length; j++) {
      const item = items[j];
      if (!item || (item.key && addonKeys[item.key])) continue;
      const p = effectiveLineAndOrig(item, item.quantity, item.key ? cartRowByLineKey(item.key) : null);
      if (p.line != null) total += p.line;
      originalTotal += p.orig != null ? p.orig : p.line != null ? p.line : 0;
      const addons = (item.key && addOnsByMain && addOnsByMain[item.key] && addOnsByMain[item.key].addons) || [];
      for (let k = 0; k < addons.length; k++) {
        const ap = effectiveLineAndOrig(addons[k], item.quantity, addons[k].key ? cartRowByLineKey(addons[k].key) : null);
        if (ap.line != null) total += ap.line;
        originalTotal += ap.orig != null ? ap.orig : ap.line != null ? ap.line : 0;
      }
    }

    document.documentElement.classList.add('zoco-correct-cart-total');
    const html =
      originalTotal > total
        ? '<s>' + formatMoneyCents(originalTotal) + '</s> ' + formatMoneyCents(total)
        : formatMoneyCents(total);
    const totals = document.querySelectorAll('[data-cart-total]');
    for (let t = 0; t < totals.length; t++) {
      let el = totals[t].parentNode && totals[t].parentNode.querySelector('[data-zoco-corrected-cart-total]');
      if (!el) {
        el = document.createElement('span');
        el.className = 'money zoco-corrected-cart-total';
        el.setAttribute('data-zoco-corrected-cart-total', '1');
        totals[t].parentNode.insertBefore(el, totals[t].nextSibling);
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    }
  }

  function rerunSoon() {
    if (rerunTimer) window.clearTimeout(rerunTimer);
    rerunTimer = window.setTimeout(function () {
      rerunTimer = null;
      runOnce();
    }, 250);
  }

  // Used by other scripts (e.g. badge fetch wrapper) to rerender after cart mutations.
  window.__cartAddonMergeSchedule = function () {
    if (!isCartLikePage()) return;
    rerunSoon();
  };

  window.__removeOrphanTpoAddons = async function () {
    if (!isCartLikePage()) return null;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      let cart = await res.json();
      cart = await removeOrphanTpoAddonsIfNeeded(cart);
      return cart;
    } catch (e) {
      return null;
    }
  };

  function bindCartRerunHooks() {
    if (document.documentElement.getAttribute('data-addon-merge-hooks') === '1') return;
    document.documentElement.setAttribute('data-addon-merge-hooks', '1');

    const cartForm = document.querySelector('form[aria-label="cart checkout"]');
    if (cartForm) {
      cartForm.addEventListener(
        'change',
        function (ev) {
          const t = ev.target;
          if (!t || !t.matches) return;
          if (t.matches('input[name="updates[]"]') || t.matches('[data-cartitem-remove]')) rerunSoon();
        },
        true
      );
    }

    window.addEventListener('cartcount:update', function () {
      rerunSoon();
    });

    document.addEventListener('product-form:cart:update', function () {
      rerunSoon();
      window.setTimeout(syncSamitaCheckoutClone, 100);
    });

    document.addEventListener('shopify:section:load', function (ev) {
      const root = ev && ev.target;
      if (!root || !root.querySelector) return;
      if (root.querySelector('form[aria-label="cart checkout"]')) {
        rerunSoon();
        window.setTimeout(syncSamitaCheckoutClone, 100);
      }
    });

    try {
      const checkoutRoot = document.querySelector('form[aria-label="cart checkout"]') || document.querySelector('.cart-checkout');
      if (checkoutRoot && window.MutationObserver) {
        const mo = new MutationObserver(function (records) {
          syncSamitaCheckoutClone();
          if (!window.__cartAddonMergeInsideRunOnce && mutationTouchesSamitaPrice(records)) rerunSoon();
        });
        mo.observe(checkoutRoot, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
          attributeFilter: ['style', 'disabled', 'aria-disabled', 'class'],
        });
      }
    } catch (e) {}
  }

  async function runOnce() {
    if (!isCartLikePage()) return;
    const listEl = getCartListEl();
    if (!listEl) return;
    if (runOnceInProgress) return;

    runOnceInProgress = true;
    window.__cartAddonMergeInsideRunOnce = true;

    try {
      ensureStyle();
      syncSamitaCheckoutClone();

      let cart;
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        cart = await res.json();
      } catch (e) {
        return;
      }

      cart = await removeOrphanTpoAddonsIfNeeded(cart);

      const addOnsByMain = buildAddonMap(cart);
      updateCorrectedCartTotal(cart, addOnsByMain);
      unhideAddonRows(listEl);

      // Clear stale mounts on rows that no longer own add-ons.
      try {
        const activeLineKeys = Object.create(null);
        const mainIds0 = Object.keys(addOnsByMain);
        for (let mk = 0; mk < mainIds0.length; mk++) {
          const ent0 = addOnsByMain[mainIds0[mk]];
          if (ent0 && ent0.main && ent0.main.key) activeLineKeys[String(ent0.main.key)] = 1;
        }
        const mounts0 = listEl.querySelectorAll('[' + MOUNT_ATTR + '="1"]');
        for (let m0 = 0; m0 < mounts0.length; m0++) {
          const mount0 = mounts0[m0];
          const row0 = mount0.closest && mount0.closest('li[data-cartitem]');
          if (!row0) continue;
          const rk0 = String(row0.getAttribute('data-cartitem-key') || '').trim();
          if (!rk0 || !activeLineKeys[rk0]) {
            if (mount0.innerHTML !== '') mount0.innerHTML = '';
            clearCombinedLineTotal(row0);
          }
        }
      } catch (e0) {}

      // Render summary under each main row.
      const mainIds = Object.keys(addOnsByMain);
      for (let j = 0; j < mainIds.length; j++) {
        const mid = mainIds[j];
        const entry = addOnsByMain[mid];
        let mainItem = entry && entry.main ? entry.main : null;
        let mainRow = null;

        if (mainItem && mainItem.key) mainRow = cartRowByLineKey(mainItem.key);
        if (!mainRow) continue;
        if (!mainItem) continue;

        let mainQty = null;
        if (mainItem.quantity != null) {
          const pq =
            typeof mainItem.quantity === 'number' ? mainItem.quantity : parseInt(String(mainItem.quantity).trim(), 10);
          if (Number.isFinite(pq)) mainQty = pq;
        }
        if (mainQty == null) {
          const domInp = mainRow.querySelector('[data-quantity-input]');
          if (domInp) {
            const dq = parseInt(String(domInp.value || '').trim(), 10);
            if (Number.isFinite(dq)) mainQty = dq;
          }
        }

        const mount = ensureMount(mainRow);
        const addons = entry && entry.addons ? entry.addons : [];
        for (let hi = 0; hi < addons.length; hi++) hideAddonRow(addons[hi]);
        renderMount(mount, addons, mainQty);
        updateCombinedLineTotal(mainRow, mainItem, addons, mainQty);
      }
    } finally {
      window.__cartAddonMergeInsideRunOnce = false;
      runOnceInProgress = false;
    }
  }

  function start() {
    bindCartRerunHooks();
    runOnce();
    window.setTimeout(rerunSoon, 700);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

